import axios from 'axios';

const fetchBillsWithHearings = async (billsData) => {
    const limit = 150;
    let hearingsData = [];
    let currentPage = 0;
    let totalPages = 1;
    try {
        while (currentPage < totalPages) {
            const billIds = billsData.map(bill => bill.id);

            const response = await axios.post(
                `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/standingCommitteeMeetingBillHearings/search?limit=${limit}&offset=${currentPage}`,
                {billIds}
            );


            const hearingsDataInCurrentPage = response.data;
            // remove canceled hearings
            const validHearingsData = (hearingsDataInCurrentPage.content || []).filter(
                (meeting) => meeting.status !== "CANCELED"
            );
            hearingsData = hearingsData.concat(validHearingsData || []);
            totalPages = hearingsDataInCurrentPage.totalPages;
            currentPage++;
        }
        // Create a map of billId to hearings
        const hearingsMap = new Map();
        hearingsData.forEach(hearing => {
            const hearingDetails = {
                meetingTime: hearing.committeeMeeting.meetingTime,
                committeeId: hearing.committeeMeeting.standingCommittee.id,
            };
            if (!hearingsMap.has(hearing.billId)) {
                hearingsMap.set(hearing.billId, []);
            }
            hearingsMap.get(hearing.billId).push(hearingDetails);
        });

        return billsData.map(bill => ({
            ...bill,
            hearingDetails: hearingsMap.get(bill.id) || [],
        }));
    } catch (error) {
        console.error("Error fetching hearings:", error);
        throw error;
    }
};

export default fetchBillsWithHearings;